import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { useMultiStyleConfig as p, Box as a } from "@chakra-ui/react";
import { Typography as o } from "../../dataDisplay/Typography/Typography.mjs";
const y = ({
  children: t,
  errorCode: d,
  errorDescription: i,
  actions: e,
  title: s,
  ...l
}) => {
  const m = p("ResponseError");
  return /* @__PURE__ */ n(a, { __css: m.container, ...l, children: [
    s && /* @__PURE__ */ r(o, { as: "h2", variant: "h2", pb: { base: 3, md: 6 }, children: s }),
    t,
    /* @__PURE__ */ r(o, { variant: "bodyBoldSmall", pt: { base: 3, md: 6 }, children: i }),
    /* @__PURE__ */ n(o, { variant: "bodySmall", children: [
      "Error code: ",
      d
    ] }),
    e && /* @__PURE__ */ r(a, { pt: { base: 3, md: 6 }, children: e })
  ] });
};
export {
  y as ResponseError
};
